import {
  Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, OnDestroy
} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-formulario-dinamico2',
  templateUrl: './formulario-dinamico.component.html',
  styleUrls: ['./formulario-dinamico.component.scss']
})

export class FormularioDinamico2Component implements OnInit, OnChanges, OnDestroy {
  snackFormInvalid;

  @Output()
  submitted: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  internalClicked: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  autocompleteOpened: EventEmitter<any> = new EventEmitter<any>();

  @Input() title = 'Título do Formulário';


  @Input() config: {} = {
    titulo: 'titulo',
    tipoAcao: 'button',
    acaoTitulo: 'Enviar',
    campos: [
      {nome: 'textInput', placeholder: 'Input de texto linha única', type: 'input', inputType: 'text'},
      {nome: 'textareaInput', placeholder: 'Input de texto linhas múltiplas', type: 'textarea'},
      {nome: 'emailInput', placeholder: 'Input de email', type: 'input', inputType: 'email'},
      {nome: 'passwordInput', placeholder: 'Input de senha', type: 'input', inputType: 'password'},
      {nome: 'numberInput', placeholder: 'Input de número', type: 'input', inputType: 'number'},
      {
        nome: 'selectInput', placeholder: 'Input de seleção', type: 'select', options: [
        {id: 1, nome: 'Opção 1'},
        {id: 2, nome: 'Opção 2'},
        {id: 3, nome: 'Opção 3'},
        {id: 4, nome: 'Opção 4'},
      ], optionsValue: 'id', optionsCaption: 'nome'
      }, {
        nome: 'radioInput', placeholder: 'Input de check único', type: 'radio', options: [
          'Opção 1', 'Opção 2', 'Opção 3', 'Opção 4']
      },
      {
        nome: 'checkboxesInput', placeholder: 'Input de check múltiplo', type: 'checkbox', options: [
        'Opção 1', 'Opção 2', 'Opção 3', 'Opção 4']
      },
      {nome: 'switchInput', placeholder: 'Input de switch', type: 'switchSlide'},
      {label: 'Botão de Envio', nome: 'submit', type: 'button', width: 100}
    ]
  };

  form: FormGroup;

  @Input() parentGrupo;

  constructor(private fb: FormBuilder, public _snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.subcribeToFormChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['title']) {
      this.title = undefined;
    }
    if (changes['config'] && changes['config'].currentValue) {
      this.form = this.criaGrupo();
      this.setValues();
    }
  }

  criaGrupo() {
    let grupo;
    grupo = this.fb.group({});

    this.config['campos'].forEach(
      control => {
        if (!control['width']) {
          control['width'] = 100;
        }
        if (control['editorTipo'] === 'checkbox') {
          const nestedGroup = this.fb.group({});
          control.editorOpcoes.opcoes.map(c => {
            nestedGroup.addControl(c, this.fb.control(null));
          });
          if (control.editorOpcoes.obrigatorio) {
            nestedGroup.addControl('hidden', this.fb.control(null, Validators.requiredTrue));
          }
          grupo.addControl(control.nome, nestedGroup);
        } else if (control['nestedForms']) {
          const nestedGroup1 = this.fb.group({});
          for (const nestedForm of control['nestedForms']) {
            const nestedGroup2 = this.fb.group({});
            for (const campo of nestedForm['campos']) {
              nestedGroup2.addControl(campo.nome, this.fb.control(null));
            }
            nestedGroup1.addControl(nestedForm['nome'], nestedGroup2);
          }
          grupo.addControl(control.nome, nestedGroup1);
        } else {
          grupo.addControl(control.nome, this.fb.control(null));
        }
      });
    return grupo;
  }

  setValues() {
    this.config['campos'].forEach(
      control => {
        if (control.editorOpcoes && control.editorOpcoes['value']) {
          const obj = {};
          obj[control.nome] = control.editorOpcoes.value;
          this.form.patchValue(obj);
        }
      });
    return this.form;
  }

  subcribeToFormChanges() {
    this.form.valueChanges.subscribe(x => {
        for (const key in x) {
          if (x.hasOwnProperty(key) && Number(x[key])) {
            for (const config of this.config['campos']) {
              if (config['nome'] === key && config.editorOpcoes['tipo'] && config.editorOpcoes['tipo'] === 'number') {
                x[key] = Number(x[key]);
              }
            }
          }
        }
        this.changed.emit(x);
        // this.form.patchValue(x, {emitEvent: false});
      }
    );
  }

  emitForm() {
    if (!this.form.invalid) {
      this.submitted.emit(this.form.value);
    } else {
      this.openSnackFieldsRequired();
    }
  }

  internalButtonClicked(event) {
    this.internalClicked.emit(event);
  }

  openSnackFieldsRequired() {
    this.snackFormInvalid = this._snackBar.open('Por favor, preencha os campos obrigatórios!', 'OK',
      {panelClass: 'error', verticalPosition: 'bottom', duration: 3000});
  }

  ngOnDestroy() {
    if (this.snackFormInvalid) {
      this.snackFormInvalid.dismiss();
    }
  }
}
